<template>
  <v-menu location="bottom">
    <template v-slot:activator="{ props }">
      <v-btn
        variant="text"
        v-bind="props"
        :prepend-icon="currentLocale.icon"
      >
        <template v-slot:prepend>
            <v-avatar size="20" :image="currentLocale.prependAvatar"></v-avatar>
        </template>
        {{ currentLocale.name }}
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="locale in locales"
        :key="locale.code"
        @click="changeLocale(locale.code)"
        :active="locale.code === $i18n.locale"
      >
        <template v-slot:prepend>
            <v-avatar size="20" :image="locale.prependAvatar"></v-avatar>
        </template>
        <v-list-item-title>
          {{ locale.name }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { locale } = useI18n()

const locales = [
  { code: 'de', name: 'DE', prependAvatar: 'https://limotak.com/images/flags/de.svg' },
  { code: 'en', name: 'EN', prependAvatar: 'https://limotak.com/images/flags/en.svg' },
  { code: 'es', name: 'ES', prependAvatar: 'https://limotak.com/images/flags/es.svg' },
  { code: 'fr', name: 'FR', prependAvatar: 'https://limotak.com/images/flags/fr.svg' },
  { code: 'it', name: 'IT', prependAvatar: 'https://limotak.com/images/flags/it.svg' },
  { code: 'pt', name: 'PT', prependAvatar: 'https://limotak.com/images/flags/pt.svg' },
  { code: 'ru', name: 'RU', prependAvatar: 'https://limotak.com/images/flags/ru.svg' },
  { code: 'tr', name: 'TR', prependAvatar: 'https://limotak.com/images/flags/tr.svg' },
  { code: 'ua', name: 'UA', prependAvatar: 'https://limotak.com/images/flags/ua.svg' },
]

const currentLocale = computed(() => {
  return locales.find(l => l.code === locale.value) || locales[0]
})

const changeLocale = (newLocale) => {
  locale.value = newLocale
  localStorage.setItem('lang', newLocale)
}
</script>